import Link from 'next/link';
import Pbucks from '@/assets/images/P-Bucks.svg';
import Image from 'next/image';
import { Tooltip } from '@nextui-org/react';
import { DiamondIcon } from '@/components/icons/diamond-icon';

interface CreditsMenuProps {
  walletPoints: number | string;
  walletLoyaltyPoints: number | string;
  variant?: 'desktop' | 'drawer';
}

export default function CreditsMenu({
  walletPoints,
  walletLoyaltyPoints,
  variant = 'desktop',
}: CreditsMenuProps) {
  if (variant === 'drawer') {
    return (
      <div className="flex w-full items-center justify-center">
        <Link
          href="/billing"
          className="flex cursor-pointer items-center space-x-2 rounded-full px-2 text-xs lg:space-x-4 lg:px-4 lg:py-2 lg:text-sm"
        >
          <div className="flex items-center">
            <Tooltip content="P-Bucks (Generate Credits)">
              <div className="group relative">
                <div className="absolute inset-[-2px] rounded-full bg-gradient-to-br from-blue-500/30 to-blue-600/30 opacity-75 blur-sm"></div>
                <Image
                  src={Pbucks}
                  width={10}
                  height={10}
                  layout="responsive"
                  alt="P-Bucks"
                  className="relative mr-1 !h-6 !w-6 animate-[pulseBorder_2s_infinite] duration-300 transition-transform group-hover:scale-110"
                />
              </div>
            </Tooltip>
            <span className="text-sm font-medium">{walletPoints}</span>
          </div>
          <span className="inline-block px-4 text-medium font-semibold text-brand group-hover:text-dark-900 dark:group-hover:text-light-600">
            Upgrade
          </span>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-center border-l border-light-400 pl-4 dark:border-dark-400 sm:absolute sm:right-0 sm:ml-auto sm:mr-16 sm:w-auto sm:justify-start">
      <Link
        href="/billing"
        className="flex cursor-pointer items-center space-x-2 rounded-full px-2 text-xs lg:space-x-4 lg:px-4 lg:py-2 lg:text-sm"
      >
        <div className="flex items-center">
          <Tooltip content="P-Bucks (Generate Credits)">
            <div className="group relative">
              <div className="absolute inset-[-2px] rounded-full bg-gradient-to-br from-blue-500/30 to-blue-600/30 opacity-75 blur-sm"></div>
              <Image
                src={Pbucks}
                width={10}
                height={10}
                layout="responsive"
                alt="P-Bucks"
                className="relative mr-1 !h-6 !w-6 animate-[pulseBorder_2s_infinite] duration-300 transition-transform group-hover:scale-110"
              />
            </div>
          </Tooltip>
          <span className="text-sm font-medium">{walletPoints}</span>
        </div>
        {/* <div className="flex items-center">
          <Tooltip content="Loyalty Points">
            <DiamondIcon className="mr-1 h-4 w-4" />
          </Tooltip>
          {walletLoyaltyPoints}
        </div> */}
        <span className="inline-block px-4 text-medium font-semibold text-brand group-hover:text-dark-900 dark:group-hover:text-light-600">
          Upgrade
        </span>
      </Link>
    </div>
  );
}
